import { verifyCaptchaToken } from './verifyCaptchaToken'

export default async (captchaToken, showToast, setIsLoading) => {
  if (!captchaToken) {
    showToast('Validation error', 'Please submit captcha')
    if (setIsLoading) setIsLoading(false)

    return false
  }

  const verifiedCaptcha = await verifyCaptchaToken(captchaToken)

  if (!verifiedCaptcha.success) {
    showToast('Captcha', 'verification failed')
    if (setIsLoading) setIsLoading(false)

    return false
  }

  return true
}
